import { stringify } from "query-string";

export type FeedTypes =
  | 'streaming'
  | 'downloads'
  | 'physical'
  | 'playlist'
  | 'charts'
  | 'radio'
  | 'discoveries'
  | 'social'
  | 'tiktok';

interface IActualityURLArgs {
  customerFilter?: Array<number | string>;
}

export default function getActualityUrl(feedType: FeedTypes, args?: IActualityURLArgs): string {
  const params = args?.customerFilter?.length ? stringify({ customerFilter: args?.customerFilter }) : '';

  return `/api/actuality/kpiDates/${feedType}${params ? `?${params}` : ''}`;
}
